
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The `}<a parentName="p" {...{
        "href": "/schema-new/named-type/Int",
        "title": "The `Int` scalar type represents non-fractional signed whole numeric values. Int can represent values between -(2^31) and 2^31 - 1"
      }}><inlineCode parentName="a">{`Int`}</inlineCode></a>{` scalar type represents non-fractional signed whole numeric values. Int can represent values between -(2^31) and 2^31 - 1.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;